import toString from "lodash/toString";

import { defaultWebsiteState } from "pro-features/components/AutocompleteDigitalMarketing/AutocompleteDigitalMarketingHelper";
import type { Recent } from "app/custom-hooks/useRecentsHook";
import { FALLBACK_COUNTRY, FALLBACK_DURATION } from "app/pages/activation/components/HomeSearch/config";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const createWebsiteUrlFromRecent = (item: Recent, pageName = defaultWebsiteState, additionalParams = {}) => {
    const category = item.data.category?.replace(/([/\s])/g, (_, curr) => {
        switch (curr) {
            case "/":
                return "~";
            default:
                return "_";
        }
    });

    const params = {
        duration: item.data.duration ?? FALLBACK_DURATION,
        country: item.data.country ?? FALLBACK_COUNTRY,
        category,
        key: `${item.data.mainItem}${
            item.data.comparedItems && item.data.comparedItems.length > 0 ? "," + toString(item.data.comparedItems) : ""
        }`,
        isWWW: "*",
        ...additionalParams,
    };

    return proNavigator.href(pageName, params);
};
